import each from 'lodash/each'

import Animation from '../classes/Animation'

import { split } from '../utils/text'

export default class extends Animation {
  constructor ({ element }) {

    const words = []
    const paragraphs = element.querySelectorAll('h1, h2, p')

    super({
      element,
      elements: {
        words
      }
    })

    this.onResize()

    if (paragraphs.length !== 0) {
      each(paragraphs, element => {
        split({ element })

        words.push(...element.querySelectorAll('span'))
      })
    } else {
      split({ element })

      words.push(...element.querySelectorAll('span'))
    }


    if ('IntersectionObserver' in window) {
      this.animateOut()
    }

  }

  animateIn () {
    super.animateIn()

    setTimeout(() => {
      this.elements.words.forEach((word, wordIndex) => {
        reveal(word, wordIndex);
      })
    }, 500)

    function reveal(el, index) {
      const timing = 0.65;
      setTimeout(() => {
        el.style.display = 'inline-block'
      }, (timing * 100) * index);
    }
  }

  animateOut () {
    super.animateOut()
  }

  onResize () {
    // prevent CLS when revealing spans (inlne-block)
    let height = this.element.clientHeight
    this.element.style.minHeight = `${height}px`
  }
}
